import rssService from '../services/rss';

export const generateCategoryRSSFeed = (query) => {
  return (dispatch) => {
    return rssService.generateCategoryRSSFeed(query).then(resp => resp);
  }
}
